import { render, staticRenderFns } from "./bannerView.vue?vue&type=template&id=4b5b28b4&scoped=true"
import script from "./bannerView.vue?vue&type=script&lang=js"
export * from "./bannerView.vue?vue&type=script&lang=js"
import style0 from "./bannerView.vue?vue&type=style&index=0&id=4b5b28b4&prod&lang=css"
import style1 from "./bannerView.vue?vue&type=style&index=1&id=4b5b28b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b28b4",
  null
  
)

export default component.exports